import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Shopping = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddShopping = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditShopping = () => {
  return (
    
      
        <Edit />
      
    
  );
};
